/* eslint-disable no-console */
class RadioButton {
    constructor() {
        this.radioButton = document.querySelector('.radioButton');
        this.slider = document.querySelector('.slider');
        this.numberCard = getComputedStyle(document.body).getPropertyValue('--card');
        this.slideIndex = 0;
        this.startX = null;
        this.scroll = this.slider.scrollLeft;
        this.initListener();
    }

    initListener() {
        this.radioButton.addEventListener('click', this.plusSlides.bind(this), false);
    }

    plusSlides(e) {
        const { value } = e.target;
        if (value > 0) this.showSlides(1);
        else this.showSlides(-1);
    }

    showSlides(side) {
        const styleCard = document.querySelector('.card');
        const width = parseInt(getComputedStyle(styleCard).getPropertyValue('width'), 10);
        const margin = parseInt(getComputedStyle(styleCard).getPropertyValue('margin-right'), 10);

        this.slideIndex += this.numberCard * side;
        this.startX = this.slider.offsetLeft;
        this.scroll += this.numberCard * (width + margin) * side;
        this.slider.scrollLeft = this.startX + this.scroll;
    }

    render() {
        const amountOfButton = 2;
        this.radioButton.innerHTML = '';
        for (let i = 0; i < amountOfButton; i += 1) {
            this.radioButton.innerHTML += `
            <input type='radio' name='answer' value=${i}>`;
        }
    }
}

export default RadioButton;
